import A11yDialog from 'a11y-dialog';

( function() {
	let dialogs = document.getElementsByClassName( 'dialog' );
	let len = dialogs.length;
	if ( ! len ) {
		return;
	}
	let body = document.body;
	//let page = body.firstElementChild || null;
	let page = document.getElementById( 'page' );

	// move dialogs to after #page container
	for ( let i = 0; i < len; i++ ) {
		body.insertBefore( dialogs[i], page );
	}
	body.insertBefore( page, dialogs[0] );

	for (let j = 0; j < len; j++) {
		let dialog = dialogs[j];
		new A11yDialog(dialog);
	}
} )();
